import { atom } from "recoil";

export const gameDetailLogModalStore = atom({
	key: "gameDetailLogModalStore",
	default: {
		loaded: false,
		show: false,
		project: 0,
		uid: 0,
	  type: 0,
		date: 0,
		gameID: 0,
		data: [],
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
		currentOption: {
			status: false,
		},
		currentSearch: "",
		sorting: {
			sortingColumn: {
				order: "",
				column: "",
			},
			isDescending: false,
		},
		pagination: {
			current: 1,
			total: 0,
			count: 0,
		},
	},
});
